import React, { useEffect, useState } from "react";
import { TYPE_GET_DATE } from "../../../../helper/const";
import { getDateChangeTime } from "../../../../helper/helper";
import FilterTime from "../../../components/FilterTime";
import DashboardCompare from "../../../Natcom/components/DashboardCompare";
import { useSelector } from "react-redux";
import { selectorDataMagicWeel, selectorDataMovitel } from "../../../../redux/selector";
import { useMemo } from "react";
import _ from "lodash";
import { Tabs } from "antd";

export default function Compare({ tabActive, handleGetData }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneDayAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } = useSelector(selectorDataMovitel)?.revenue;
  const [tabCompare, setTabCompare] = useState("total_reg");
  const onChangeTabs = (key) => {
    setTabCompare(key);
  };
  const itemsTab = [
    {
      key: "total_reg",
      label: "Register",
    },
    {
      key: "total_reg_revenue",
      label: "Register Revenue",
    },
    {
      key: "total_renew",
      label: "Renew",
    },
    {
      key: "total_renew_revenue",
      label: "Renew Revenue",
    },
    {
      key: "total_reg_renew",
      label: "Total Reg & Renew",
    },
    {
      key: "total_revenue",
      label: "Total Revenue",
    },
  ];
  useEffect(() => {
    if (tabActive !== "3") {
      return;
    }
    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const dataCharts = useMemo(() => {
    if (_.isEmpty(result)) {
      return [];
    }
    const { dataHourMap } = result;
    const handleGetData = (data, category, dataItems) => {
      const defineData = [
        { hour: "00:00", total_hour: 0, category },
        { hour: "01:00", total_hour: 0, category },
        { hour: "02:00", total_hour: 0, category },
        { hour: "03:00", total_hour: 0, category },
        { hour: "04:00", total_hour: 0, category },
        { hour: "05:00", total_hour: 0, category },
        { hour: "06:00", total_hour: 0, category },
        { hour: "07:00", total_hour: 0, category },
        { hour: "08:00", total_hour: 0, category },
        { hour: "09:00", total_hour: 0, category },
        { hour: "10:00", total_hour: 0, category },
        { hour: "11:00", total_hour: 0, category },
        { hour: "12:00", total_hour: 0, category },
        { hour: "13:00", total_hour: 0, category },
        { hour: "14:00", total_hour: 0, category },
        { hour: "15:00", total_hour: 0, category },
        { hour: "16:00", total_hour: 0, category },
        { hour: "17:00", total_hour: 0, category },
        { hour: "18:00", total_hour: 0, category },
        { hour: "19:00", total_hour: 0, category },
        { hour: "20:00", total_hour: 0, category },
        { hour: "21:00", total_hour: 0, category },
        { hour: "22:00", total_hour: 0, category },
        { hour: "23:00", total_hour: 0, category },
      ];

      if (_.isEmpty(data)) {
        return defineData;
      }

      for (let i = 0; i < defineData.length; i++) {
        const datas = data.find((item) => item?.hour == defineData[i]?.hour);
        defineData[i].total_hour = +datas?.[dataItems] || 0;
      }

      return defineData;
    };
    const dataStart =
      handleGetData(dataHourMap[startDate], startDate, tabCompare) || [];
    const dataEnd =
      handleGetData(dataHourMap[endDate], endDate, tabCompare) || [];

    return [...dataStart, ...dataEnd];
  }, [result, startDate, endDate, tabCompare]);

  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>
      <div className="container-dashboard">
        <Tabs defaultActiveKey="1" items={itemsTab} onChange={onChangeTabs} />
      </div>
      <div>
        <DashboardCompare
          dataChart={dataCharts}
          startDate={startDate}
          endDate={endDate}
        />
      </div>
    </>
  );
}
